import React from 'react';
import './GameField.css'; // Используем существующие стили

interface LoadingIndicatorProps {
  message?: string;
}

/**
 * Компонент для отображения индикатора загрузки
 */
const LoadingIndicator: React.FC<LoadingIndicatorProps> = ({ 
  message = 'Создание нового элемента...' 
}) => {
  return (
    <div className="loading-indicator">
      <div className="spinner"></div>
      <div className="loading-text">{message}</div>
    </div>
  );
};

export default LoadingIndicator; 